import { render, staticRenderFns } from "./mo-date-input-field.html?vue&type=template&id=da0bbec6&scoped=true&external"
import script from "./mo-date-input-field.ts?vue&type=script&lang=ts&external"
export * from "./mo-date-input-field.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-date-input-field.scss?vue&type=style&index=0&id=da0bbec6&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0bbec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0bbec6')) {
      api.createRecord('da0bbec6', component.options)
    } else {
      api.reload('da0bbec6', component.options)
    }
    module.hot.accept("./mo-date-input-field.html?vue&type=template&id=da0bbec6&scoped=true&external", function () {
      api.rerender('da0bbec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-date-input-field/mo-date-input-field.vue"
export default component.exports